import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
} from 'react-bootstrap';
import diff from 'object-diff';
import AgencyEditForm from './AgencyEditForm';

class AgencyModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    const initialValues = this.props.agency;
    const submitValues = diff(initialValues, values);
    console.log('handle submit values: ', submitValues);
    this.props.editAgency(this.props.agency.id, submitValues);
    this.props.onClose();
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  render() {
    const modalLabel = 'Edit Agency';

    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{ modalLabel }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AgencyEditForm
            agency={this.props.agency}
            initialValues={this.props.agency}
            onSubmit={this.handleSubmit}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

AgencyModal.propTypes = {
  agency: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.String,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  editAgency: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default AgencyModal;



// WEBPACK FOOTER //
// src/routes/agency/components/AgencyEditModal.js